import { useGetFilterTooltipsQuery } from 'features/api/data-api';
import { useMemo } from 'react';
import useIsCompatibilityPathway from './use-is-compatibility-pathway';

// Admin-managed System Filters info tooltips (AHA-6681): fetched once, and
// only on the ducted path — the feature is ducted-scoped, so the ductless
// panel stays byte-identical (no fetch, no icons). Returns a code → content
// map; callers render an info icon only when their code is present, so a
// missing or blank row means no icon rather than an empty tooltip.
export default function useFilterTooltips(): Record<string, string> {
  const isDucted = useIsCompatibilityPathway();
  const { data } = useGetFilterTooltipsQuery(undefined, { skip: !isDucted });

  return useMemo(() => {
    const contentByCode: Record<string, string> = {};
    (data ?? []).forEach((tooltip) => {
      if (tooltip.content.trim() !== '') {
        contentByCode[tooltip.code] = tooltip.content;
      }
    });
    return contentByCode;
  }, [data]);
}
